import * as $ from "jquery";
import * as _ from "lodash";
import * as Backbone from "backbone";
import {BaseView} from "../../_BaseViews";
import {BacnetConfigView, ProcessedDeviceDiscovery} from "./BacnetConfigView";
import {PermissionCollection} from "../../../collections/Permissions";
import {BacnetUnitRecord} from "../../../collections/BacnetUnits";
import {BacnetPropertyCollection, BacnetPropertyRecord} from "../../../collections/BacnetProperties";
import {BacnetObjectTypeCollection} from "../../../collections/BacnetObjectTypes";


var template = require('templates/settings/sensor_config/bacnetoperation.html');
var autoBlockTemplate = require('templates/settings/sensor_config/bacnetautoblock.html');
autoBlockTemplate = _.template(autoBlockTemplate);

export interface UIChannel {
    name: string;
    unit: string;
    decimals: number;
}

interface BacnetUIOperationObject {
    objectid: number,
    property: number,
    channelName?: string;
    unit?: string;
    channelDecimals?: number;
}

export interface BacnetUIOperation {
    device: string;
    operations: BacnetUIOperationObject[]
}


interface BacnetOperationViewOptions extends Backbone.ViewOptions<Backbone.Model> {
    parentView: BacnetConfigView;
    opId: string;
    opNum: number;
    sensorId: number;
    initialOperations: BacnetUIOperation;
    discovery: {[key: string]: ProcessedDeviceDiscovery};
    bacnetProps: {[key: number]: BacnetPropertyRecord};
    bacnetUnits: {[key: number]: BacnetUnitRecord};
    permissionCollection: PermissionCollection;
    installId: number;
}


export class BacnetOperationView extends BaseView {

    options: BacnetOperationViewOptions;
    tab = 'discovery';
    nextBlockId = 1;
    removed = false;
    bacnetProperties = new BacnetPropertyCollection();
    bacnetObjectTypes = new BacnetObjectTypeCollection();

    device: string;
    operations: BacnetUIOperationObject[];

    template = _.template(template);

    constructor(options: BacnetOperationViewOptions) {
        super(_.extend({
            className: 'hspace-10',
            events: {
                'click .manualSelectByTypeRadio': 'handleManualSelectByTypeRadioClick',
                'click .bacnet-operation-remove-button': 'removeModelView',
                'click .bacnet-add-object-selector': 'handleAddSelector',
                'click .bacnet-add-all-objects-selector': 'handleAddAllSelector',

                'change .bacnet-auto-device-selector': 'handleAutoDeviceChangeEvent',
                'change .bacnet-auto-objectid-selector': 'handleAutoObjectIdChangeEvent',
                'change .bacnet-auto-property-selector': 'handleAutoPropertySelectChangeEvent',

                'click .bacnet-trash-selector': 'handleTrashClicked',
                'click .bacnet-operation-discovery-tab': 'handleTabSelectDiscovery',
                'click .bacnet-operation-manual-tab': 'handleTabSelectManual'
            }
        }, options));

        if(this.options.initialOperations){
            this.device = this.options.initialOperations.device;
            this.operations = this.options.initialOperations.operations;
        } else {
            this.device = '';
            this.operations = [{
                objectid: null,
                property: 85
            }];
        }
    };

    validateForm() {
        var errors = [];

        var addr = this.$('.bacnet-auto-device-selector').val();
        var objIdInputs = this.$('.bacnet-auto-objectid-selector');
        var popertySelectors = this.$('.bacnet-auto-property-selector');

        // Validate Device
        if(addr === "") errors.push('Device Address is required and must not be empty');
        addr = Number(addr);

        // Validate ObjId
        for(var i=0; i<objIdInputs.length; i++){
            var input = $(objIdInputs[i]).val();
            if(input === "") errors.push('Object Identifier is required and must not be empty');
            input = Number(input);
            if(!_.isNumber(input) || _.isNaN(input) || input < 0 || input > 4294967295) errors.push('Object Identifiers must be between 0 and 4294967295 (both inclusive)');

            var instance = (input % 4194304);
            if(instance < 0 || instance > 4194303) errors.push('Object Instance Numbers must be between 0 and 4194303 (both inclusive)');
        }

        // Validate Property
        for(var i=0; i<popertySelectors.length; i++) {
            var input = $(popertySelectors[i]).val();
            if(input === "" || Number(input) < 0 || Number(input) > 65535 || !_.isNumber(Number(input)) || _.isNaN(Number(input))){
                var objid =  (<string> $(objIdInputs[i]).val());
                var objname = objid;
                if(_.has(this.options.discovery, addr)){
                    if(_.has(this.options.discovery[addr].objects, objid)){
                        objname = this.options.discovery[addr].objects[objid].name;
                    }
                }

                if(input === "") errors.push('You must select a property to read for object "' + objname +'"');
                if(Number(input) < 0 || Number(input) > 65535) errors.push(
                    'Property Number for Object "' + objname + '" must be between 0 and 65535 (both inclusive)'
                );
            }
        }
        return errors;
    }

    // User changed device on the Discovery tab
    handleAutoDeviceChangeEvent() {
        var device = Number(this.$('.bacnet-auto-device-selector').val());

        this.$('.bacnet-block-auto').remove();
        this.addEmptyBlock();
    }

    replaceAutoPropertyDropDown(device, autoBlock, autoSelectProp) {
        var objSelector = autoBlock.find('.bacnet-auto-objectid-selector');
        var propSelector = autoBlock.find('.bacnet-auto-property-selector');
        var previouslySelected = propSelector.val();
        propSelector.empty();

        propSelector.prop('disabled', false);

        var objectId = objSelector.val();
        if(_.has(this.options.discovery[device].objects, objectId)){
            var automaticallySelectedProp = false;

            propSelector.append($('<option>')
                .addClass('bacnet-auto-property-selector-select-please-select')
                .text('Please Select')
                .attr('value','')
            );

            _.each(_.sortBy(this.options.discovery[device].objects[objectId].uniqueProperties, 'name'), (property) => {
                var option = $('<option>').text(property.name).attr('value', property.number);
                if(autoSelectProp && property.number === 85 && previouslySelected === ''){
                    option.prop('selected', true);
                    automaticallySelectedProp = true;
                } else if (autoSelectProp && property.number == previouslySelected &&  previouslySelected !== ''){
                    option.prop('selected', true);
                    automaticallySelectedProp = true;
                }
                propSelector.append(option);
            });
            if(autoSelectProp && !automaticallySelectedProp) propSelector.find('.bacnet-auto-property-selector-select-please-select').prop('selected', true);
        }else{
            propSelector.prop('disabled', true);
        }

        if(autoSelectProp){
            this.handleAutoPropertySelectChange(autoBlock);
        }
    }

    handleAutoObjectIdChangeEvent(e: JQuery.UIEventBase) {
        var blockId = $(e.currentTarget).parents('.bacnet-block').attr('data-block-id');
        var manualBlock =  this.$('.bacnet-block-manual[data-block-id="' + blockId + '"]');
        var autoBlock =  this.$('.bacnet-block-auto[data-block-id="' + blockId + '"]');

        this.handleAutoObjectIdChange(autoBlock, manualBlock);
    }

    handleAutoObjectIdChange(autoBlock, manualBlock) {
        var selector = autoBlock.find('.bacnet-auto-objectid-selector');
        var objIdInput = manualBlock.find('.bacnet-objectid-selector');
        objIdInput.val(selector.val());

        // Auto select 'Present Value' if available
        var device = this.$('.bacnet-auto-device-selector').val();
        this.replaceAutoPropertyDropDown(device, autoBlock, true);

        // Update Channel Name & Unit
        this.updateBlockChannelNameUnit(autoBlock);
    }

    handleAutoPropertySelectChangeEvent(e: JQuery.UIEventBase) {
        var blockId = $(e.currentTarget).parents('.bacnet-block').attr('data-block-id');
        var autoBlock =  this.$('.bacnet-block-auto[data-block-id="' + blockId + '"]');

        this.handleAutoPropertySelectChange(autoBlock);
    }

    handleAutoPropertySelectChange(autoBlock) {
        var autoPropertySelector = autoBlock.find('.bacnet-auto-property-selector');
        autoBlock.find('.bacnet-auto-channel-name').prop('disabled', autoPropertySelector.val() === '');
        autoBlock.find('.bacnet-auto-unit').prop('disabled', autoPropertySelector.val() === '');
        autoBlock.find('.bacnet-auto-decimals').prop('disabled', autoPropertySelector.val() === '');

        this.updateBlockChannelNameUnit(autoBlock);
    }

    handleTrashClicked(e: JQuery.UIEventBase) {
        var blockId = $(e.currentTarget).parents('.bacnet-block').attr('data-block-id');
        this.$('.bacnet-block[data-block-id="' + blockId + '"]').remove();
    }

    updateBlockChannelNameUnit(autoBlock) {
        var device = this.$('.bacnet-auto-device-selector').val();
        var objId = autoBlock.find('.bacnet-auto-objectid-selector').val();
        var property = autoBlock.find('.bacnet-auto-property-selector').val();

        var name, unit;
        if(device === '' || objId === '' || property === ''){
            name = '';
            unit = '';
        } else {
            name = this.options.parentView.getChannelNameForNewBlock(device, Number(objId), Number(property));
            unit = this.options.parentView.getUnitForBlock(device, Number(objId), Number(property));
        }

        autoBlock.find('.bacnet-auto-channel-name').val(name);
        autoBlock.find('.bacnet-auto-unit').val(unit);
    }

    addNewBlock(device, objectId, property, channelName, channelUnit, channelDecimals) {
        var canEdit = this.options.permissionCollection.canModifySensorConfig(this.options.installId);
        var newBlock = $(<string> autoBlockTemplate({
            canEdit: canEdit,
            i: this.nextBlockId,
            device: device,
            discovery: this.options.discovery,
            objectId: objectId,
            property: property,
            channelName: channelName,
            channelUnit: channelUnit,
            channelDecimals: channelDecimals,
            bacnetProperties: this.bacnetProperties,
            bacnetObjectTypes: this.bacnetObjectTypes
        }));
        this.$('.bacnet-auto-blocks-container').append(newBlock);
        this.nextBlockId++;

        return newBlock;
    }

    addEmptyBlock() {
        var device = this.$('.bacnet-auto-device-selector').val();
        device = device ? device: null;

        var newBlock = this.addNewBlock(device, null, 85, null, null, null);
        this.updateBlockChannelNameUnit(newBlock);
        this.delegateEvents();

        return newBlock;
    }

    handleAddSelector() {
        this.addEmptyBlock();
    }

    handleAddAllSelector() {
        var device = (<string> this.$('.bacnet-auto-device-selector').val());
        if(!_.has(this.options.discovery, device))return;

        var sortedObjects = _.sortBy(_.values(this.options.discovery[device].objects), 'name');

        _.each(sortedObjects, (obj) => {
            if(!obj.properties.length) return;

            var match = _.find(obj.properties, {number: 85});
            var prop = match ? match.number : obj.properties[0].number;

            var name = this.options.parentView.getChannelNameForNewBlock(device, obj.objectId, prop);
            var unit = this.options.parentView.getUnitForBlock(device, obj.objectId, prop);

            this.addNewBlock(device, obj.objectId, prop, name, unit, null)
        });
    }

    removeModelView() {
        this.remove();
        this.removed = true;
    }

    render(errors?) {
        this.$el.html(this.template({
            errors: errors ? errors: [],
            opId: this.options.opId,
            opNum: this.options.opNum,
            discovery: this.options.discovery,
            device: this.device,
            tab: this.tab,
            permissionCollection: this.options.permissionCollection,
            installId: this.options.installId
        }));

        _.each(this.operations, (op) => {
            this.addNewBlock(this.device, op.objectid, op.property, op.channelName, op.unit, op.channelDecimals);
        });

        this.delegateEvents();
        return this;
    }

    handleTabSelectDiscovery() {
        this.tab = 'discovery';
    }

    handleTabSelectManual() {
        this.tab = 'manual';
    }

    getConfigFromUI() {
        var processedConfig = [];

        var addr = this.$('.bacnet-auto-device-selector').val();
        var objIdInputs = this.$('.bacnet-auto-objectid-selector');
        var propertySelectors = this.$('.bacnet-auto-property-selector');

        for(var i=0; i<objIdInputs.length; i++){
            var prop = $(propertySelectors[i]).val();
            var obj = $(objIdInputs[i]).val();

            processedConfig.push({
                objectId: obj === "" ? null: Number(obj),
                property: prop === "" ? null: Number(prop),
                addr: addr
            });
        }
        return processedConfig;
    }

    getChannelsFromUI() {
        var channels: {[key: string]: UIChannel} = {};

        var addr = this.$('.bacnet-auto-device-selector').val();
        var objIdInputs = this.$('.bacnet-auto-objectid-selector');
        var propertySelectors = this.$('.bacnet-auto-property-selector');
        var channelNames = this.$('.bacnet-auto-channel-name');
        var channelUnits = this.$('.bacnet-auto-unit');
        var channelDecimals = this.$('.bacnet-auto-decimals');

        for(var i=0; i<objIdInputs.length; i++){
            var prop = (<string> $(propertySelectors[i]).val());
            var obj = (<string> $(objIdInputs[i]).val());
            var name = (<string> $(channelNames[i]).val());
            var unit = (<string> $(channelUnits[i]).val());
            var decimals = Number($(channelDecimals[i]).val());

            if(decimals === -1) decimals = null;

            var key = this.options.parentView.getUniqueUIChannelIdentifier(addr, obj, prop);
            channels[key] = {
                name: name,
                unit: unit,
                decimals: decimals
            }
        }

        return channels;
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/settings/sensor_config/BacnetOperation.ts